<section class="antrag-creation--top-section">
    <h1>Antragsart wählen</h1>
</section>
<section class="antrag-creation--bottom-section">
    <mat-accordion
        multi="true"
        class="antrag-creation__accordion"
        *ngIf="openFoerderbereiche$ | async; let openFoerderbereiche">
        <ng-container *ngFor="let foerderbereich of foerderbereiche$ | async">
            <mat-expansion-panel
                class="antrag-creation--bottom-section__card"
                [hideToggle]="true"
                [disabled]="foerderbereich.bezeichnung.includes('zukünftig verfügbar')"
                [ngClass]="{'antrag-creation--bottom-section__card__disabled-panel': foerderbereich.bezeichnung.includes('zukünftig verfügbar')}"
                (opened)="openFoerderbereiche[foerderbereich.bezeichnung] = true"
                (closed)="openFoerderbereiche[foerderbereich.bezeichnung] = false"
                [attr.data-testid]="foerderbereich.bezeichnung">
                <mat-expansion-panel-header style="display: flex; min-height: 5rem;">
                    <mat-panel-title class="!text-text-light text-accordeon-title" style="font-weight: normal;">
                        {{ foerderbereich.bezeichnung }}
                    </mat-panel-title>
                    <img
                        *ngIf="!openFoerderbereiche[foerderbereich.bezeichnung] && !foerderbereich.bezeichnung.includes('zukünftig verfügbar')"
                        src="assets/images/svgs/plus-large-svgrepo-com.svg"
                        alt="Akkordion öffnen Icon" />
                    <img
                        *ngIf="openFoerderbereiche[foerderbereich.bezeichnung] && !foerderbereich.bezeichnung.includes('zukünftig verfügbar')"
                        src="assets/images/svgs/minus-svgrepo-com.svg"
                        alt="Akkordion öffnen Icon" />
                </mat-expansion-panel-header>
                <div class="antrag-creation--bottom-section__accordion-body">
                    <ng-container *ngFor="let foerderart of foerderarten$ | async">
                        <ng-container *ngIf="foerderart.foerderbereichBezeichnung === foerderbereich.bezeichnung">
                            <button
                                (click)="navigateToFormular(foerderart.gatewayShortname, foerderart.bezeichnung, foerderart.id)"
                                [attr.data-testid]="foerderart.bezeichnung">
                                <app-card>
                                    <div class="antrag-creation--bottom-section__button-card">
                                        <p class="text-accordeon-card-title" style="font-size: 14px; width: 60%">{{ foerderart.bezeichnung }}</p>
                                        <img
                                            src="/assets/images/svgs/arrow-right-thin.svg"
                                            class="antrag-creation--bottom-section__accordion-body__svg"
                                            alt="Pfeil rechts"
                                        />
                                        <p class="text-plain" style="width: 30%;">{{ foerderart.rechtsgrundlage }}</p>
                                        <p class="text-plain">{{ gueltigBisText(foerderart.gueltigBis) }}</p>
                                    </div>
                                </app-card>
                            </button>
                        </ng-container>
                    </ng-container>
                </div>
            </mat-expansion-panel>
        </ng-container>
    </mat-accordion>
</section>
